module.exports = __webpack_public_path__ + "static/img/店铺_22.44e918c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store/images/店铺_22.jpg
// module id = 47OB
// module chunks = 1